module.exports = __webpack_public_path__ + "img/ErplyPOS.06f664cb.svg";